<script setup lang="ts">
import { computed } from 'vue'
import type { Locale, LocaleCode } from '@papershift/locale/src/i18n'
import { ChevronDownIcon } from '@papershift/ui/src/icons'
import gbFlagUrl from '@/assets/gb.svg'
import deFlagUrl from '@/assets/de.svg'

const props = defineProps<{
  currentLocale: Locale
  locales: Locale[]
}>()
defineEmits<{
  'locale-change': [code: LocaleCode]
}>()

const options = computed(() =>
  props.locales.map((locale) => ({
    value: locale.code,
    label: locale.name,
  }))
)

function getFlagUrl(code: LocaleCode) {
  switch (code) {
    case 'en':
      return gbFlagUrl
    case 'de':
      return deFlagUrl
  }
}
</script>

<template>
  <Dropdown id="locale-switcher" :options="options">
    <template #trigger>
      {{ currentLocale.name }}
      <ChevronDownIcon class="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
    </template>

    <template #option="{ option, active }">
      <a
        href="#"
        :class="[
          active ? 'bg-gray-200 text-gray-900' : 'text-gray-700',
          'group flex items-center px-4 py-2 text-sm',
        ]"
        @click="$emit('locale-change', option.value)"
      >
        <img
          :alt="option.label"
          :src="getFlagUrl(option.value as LocaleCode)"
          class="mr-3 w-6"
        />
        {{ option.label }}
      </a>
    </template>
  </Dropdown>
</template>
